import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers';
import { ReactComponent as TokkoLogoSvg } from './tokko_logo.svg';
import {
  Container,
  Header,
  Content,
  Title,
  Description,
  LearnMoreLink,
  LogoContainer,
  TokkoLogoContainer,
  ToggleContainer,
  ToggleLabel,
  Toggle,
  ToggleInput,
  ToggleSlider,
  PercentageContainer,
  PercentageOption,
  RadioButton
} from './styles';

const ShareCommissionSection = ({ register, handleFieldChange, percentage_shared = 0 }) => {
  const { t } = useTranslation();
  const device = getDevice();
  const [isShared, setIsShared] = useState(percentage_shared !== 0 ? true : false);
  const [selectedPercentage, setSelectedPercentage] = useState(percentage_shared !== 0 ? percentage_shared : 30);
  const [isClickedLearnMore, setIsClickedLearnMore] = useState(false);

  useEffect(() => {
    handleFieldChange('share_commission', isShared ? selectedPercentage : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShared]);

  const handleToggle = () => {
    setIsShared(!isShared);
  };

  const handlePercentageChange = percentage => {
    setSelectedPercentage(percentage);
    handleFieldChange('share_commission', percentage);
  };

  const handleLearnMore = () => {
    window.open(t('professionalPubli.shareCommission.learnMore.link'), '_blank');
    setIsClickedLearnMore(true);
  };

  return (
    <Container device={device} data-publi='professionalPubli-publishStep-shareCommission-comtainer'>
      <Header device={device}>
        <Content device={device}>
          <Title device={device} data-publi='professionalPubli-publishStep-shareCommission-title'>
            {t('professionalPubli.shareCommission.title')}
          </Title>
          <Description device={device} data-publi='professionalPubli-publishStep-shareCommission-description'>
            {t('professionalPubli.shareCommission.description')}{' '}
            <LearnMoreLink
              clicked={isClickedLearnMore}
              onClick={handleLearnMore}
              data-publi='professionalPubli-publishStep-shareCommission-learnMore'
            >
              {t('professionalPubli.shareCommission.learnMore')}
            </LearnMoreLink>
          </Description>
        </Content>
        <LogoContainer>
          <TokkoLogoContainer device={device} data-publi='professionalPubli-publishStep-shareCommission-tokkoLogoSvg'>
            <TokkoLogoSvg />
          </TokkoLogoContainer>
        </LogoContainer>
      </Header>

      <ToggleContainer device={device} data-publi='professionalPubli-publishStep-shareCommission-toggle'>
        <ToggleLabel device={device} data-publi='professionalPubli-publishStep-shareCommission-label'>
          {t('professionalPubli.shareCommission.toggle.label')}
        </ToggleLabel>
        <Toggle>
          <ToggleInput
            data-publi='professionalPubli-publishStep-shareCommission-checkbox'
            type='checkbox'
            checked={isShared}
            onChange={handleToggle}
          />
          <ToggleSlider checked={isShared} />
        </Toggle>
      </ToggleContainer>

      {isShared && (
        <PercentageContainer
          device={device}
          data-publi='professionalPubli-publishStep-shareCommission-percentageContainer'
        >
          <PercentageOption
            device={device}
            data-publi='professionalPubli-publishStep-shareCommission-percentageOption-30'
          >
            <RadioButton
              type='radio'
              name='percentage'
              value={30}
              checked={isShared && selectedPercentage === 30}
              onChange={() => handlePercentageChange(30)}
              data-publi='professionalPubli-publishStep-shareCommission-radioButton-30'
              {...register('share_commission')}
            />
            {t('professionalPubli.shareCommission.percentage.30')}
          </PercentageOption>
          <PercentageOption
            device={device}
            data-publi='professionalPubli-publishStep-shareCommission-percentageOption-50'
          >
            <RadioButton
              type='radio'
              name='percentage'
              value={50}
              checked={isShared && selectedPercentage === 50}
              onChange={() => handlePercentageChange(50)}
              data-publi='professionalPubli-publishStep-shareCommission-radioButton-50'
              {...register('share_commission')}
            />
            {t('professionalPubli.shareCommission.percentage.50')}
          </PercentageOption>
        </PercentageContainer>
      )}
    </Container>
  );
};

export default ShareCommissionSection;
